module.exports = __webpack_public_path__ + "static/img/commonpay_old.89c3fa4a.png";